// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-xsjfxxcx-jxXsjfxxcx-index-main_right_content-2-DyS","table":"components-tjcx-xsjfxxcx-jxXsjfxxcx-index-table-29j5T"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/xsjfxxcx/jxXsjfxxcx/index.css
// module id = 566
// module chunks = 0